import React from 'react';
import ReactDOM from 'react-dom';
import * as RTK from '@reduxjs/toolkit';
import * as ReactRedux from 'react-redux';

window.React = React;
window.ReactDOM = ReactDOM;
window.RTK = RTK;
window.ReactRedux = ReactRedux;
